import React from 'react';

// Hooks
import useWealth from "../../hooks/ui/useWealth";

// Components
import ColorSectionTextQuote from "../../components/color-section-text-quote";
import WithoutColorSection from "../../components/without-color-section";

function TemplateView() {
    const { sections } = useWealth();
    
    return (
      <main>
        {
          sections.map((item, idx) => {
              if (item.fields && item.sys.contentType.sys.id === 'componentColorBgWithTextAndQuote') {
                  const { accentColor, description, title, backgroundColor, quoteText } = item.fields;
                  return (
                    <ColorSectionTextQuote
                      key={idx}
                      idx={idx}
                      accentColor={accentColor}
                      description={description}
                      title={title}
                      backgroundColor={backgroundColor}
                      quoteText={quoteText}/>
                  )
              } else if (item.fields && item.sys.contentType.sys.id === "componentWithoutBgWithTitleAndButton") {
                const { accentColor, description, title, backgroundColor, buttonTitle, buttonSecondTitle, buttonLink, secondButtonLink, newTab, showSecondButton  } = item.fields;
                  return (
                    <WithoutColorSection
                      key={idx}
                      accentColor={accentColor}
                      description={description}
                      title={title}
                      backgroundColor={backgroundColor}
                      buttonTitle={buttonTitle}
                      buttonLink={buttonLink}
                      buttonSecondTitle={buttonSecondTitle}
                      secondButtonLink={secondButtonLink}
                      showSecondButton={showSecondButton}
                      newTab={newTab} />
                  )
              } else return null
          })
        }
      </main>
    );
}

export default TemplateView;
